// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"TransactionsHistory_buttonWrapper__QYP_m","buttonTransactions":"TransactionsHistory_buttonTransactions__2VIrm"};